export default __webpack_public_path__ + "static/media/Finger_lickInMob.fc23e8b1.svg";